import Turbolinks from "turbolinks";

// functionality to focus on the shipment search box
// by pressing the "/" key and entering the shipment number
// the forward slash is a common search shortcut in many applications

function addShipmentSearchHandlers() {
  const searchBox = "#shipment-search";

  $(document)
    .on("keypress", function (e) {
      if (e.key == "/" && e.target.nodeName == "BODY") {
        e.preventDefault();
        $(searchBox).focus();
      }
    })
    .on("turbolinks:before-cache", (_e) => {
      // clear the searchbox in the cached version
      $(searchBox).val("");
    })
    .on("click", "tr.shipment-search-result", (e) => {
      Turbolinks.visit(e.currentTarget.dataset.shipmentPath);
    });
}

addShipmentSearchHandlers();
